// API /////////////////////////////
export const GetOtpCodeUrl = (): string =>
  `/Account/AuthenticateWithMobileAndBranchId`;
export const SendOtpUrl = (): string => '/Account/LoginConfirmMobile';
export const ResendOtpUrl = (): string => '/Account/ReSendCodeForBranch';
